export var SORTING_ICON_CLASS_NAME = 'view-mode-sorting-icon';
export var IS_DISABLED_CLASS_NAME = 'is-disabled';
export var SORT_INDEX_DATA_ATTRIBUTE = 'data-sort-index';